import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Custom">
                            <h2>Hire Enterprise Technology Services At The First Call</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>TekRevol’s enterprise technology services help organizations focus on creating and delivering optimum value to their customers. From improving the processes to implementing technology-enabled and efficient solutions, we develop end-to-end strategies to help our clients cope with ever-changing business requirements.</p>
                       <p>We use business consulting technology to provide your business an avenue to explore unending possibilities for growth. Our global team of strategists, advisors, and technology experts works diligently to deliver enterprise-grade technology solutions to enable your business for the next level.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;